window.addEventListener('load', function () {
  initFilterArticle();

  setupBlogFilterClickHandlers();
});

function initFilterArticle() {
  const urlParams = new URLSearchParams(window.location.search);
  for (const [key, value] of urlParams) {
    if (key === 'filter') {
      const section = document.getElementById('shopify-section-product-filter-home');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
      const filterItem = document.querySelector('.blog-filter li[data-value="' + value + '"]');
      if (filterItem) {
        filterItem.click();
      }
    }
  }
}

function setupBlogFilterClickHandlers() {
  const filterList = document.querySelector('.blog-filter');
  if (!filterList) return;
  const filterItems = filterList.querySelectorAll('li');
  const classFilerActive = 'filter-active';

  filterItems.forEach(function (item) {
    const filterLink = item.querySelector('a');
    if (!filterLink) return;

    filterLink.addEventListener('click', function (e) {
      if (window.innerWidth < 989) {
        e.preventDefault();
        
        if(filterList.classList.contains('active')) {
          filterList.classList.remove('active');
          if(!item.classList.contains(classFilerActive)) {
            window.location.href = this.href;
          }
        } else {
          filterList.classList.add('active');
        }
      }
    });
  });
}
